'use strict';
const angular = require('angular');
const {isNumber, isString} = angular;

module.exports =  [
  FileDropDirective];

function FileDropDirective() {
  return {
    controller: ['$scope', '$element', '$attrs', '$parse', FileDropController],
    link: function onFileDropDirective($scope, $element, $attrs, controller) {
      var validMimeTypes = $attrs.validMimeTypes;
      var onHoverClass = isString($attrs.onFileDragOverClass) ? $attrs.onFileDragOverClass : '';

      $element.on('dragover', processDragOverOrEnter);
      $element.on('dragenter', processDragOverOrEnter);
      $element.on('dragleave', onDragLeave);
      $element.on('drop', onDrop);

      $scope.$on('$destroy', cleanup);

      function onDrop($event) {
        $event.preventDefault();
        var files = getDataTransfer($event).files;
        //var reader = new FileReader();
        //var name = file.name;
        //var type = file.type;
        //var size = file.size;
        //reader.readAsDataURL(files[0]);

        $element.removeClass(onHoverClass);

        //console.log('dropped files', files);
        controller.callFileHandler(files);

        //reader.onload = function (evt) {
        //  if (checkSize(size) && isTypeValid(type)) {
        //    $scope.$apply(function () {
        //      $scope.file = evt.target.result;
        //      if (angular.isString($scope.fileName)) {
        //        return $scope.fileName = name;
        //      }
        //    });
        //
        //    return $scope.$emit('file-drop', {
        //      file: $scope.file,
        //      type: type,
        //      name: name,
        //      size: size
        //    });
        //  }
        //};
        return false;
      }

      function onDragLeave() {
        return $element.removeClass(onHoverClass);
      }

      function getDataTransfer(event) {
        return event.dataTransfer || event.originalEvent.dataTransfer;
      }

      function processDragOverOrEnter(event) {
        if (event) {
          $element.addClass(onHoverClass);
          if (event.preventDefault) {
            event.preventDefault();
          }
          if (event.stopPropagation) {
            return false;
          }
        }
        getDataTransfer(event).effectAllowed = 'copy';
        return false;
      }

      function checkSize(size) {
        if (isNumber($attrs.maxFileSize) && size < $attrs.maxFileSize) {
          return true;
        } else {
          alert("File must be smaller than " + $attrs.maxFileSize + " bytes");
          return false;
        }
      }

      function isTypeValid(type) {
        if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
          return true;
        } else {
          alert("Invalid file type.  File must be one of following types " + validMimeTypes);
          return false;
        }
      }

      function cleanup() {
        $element.off('dragover', processDragOverOrEnter);
        $element.off('dragenter', processDragOverOrEnter);
        $element.off('dragleave', onDragLeave);
        $element.off('drop', onDrop);
      }
    }
  }
}

function FileDropController($scope, $element, $attrs, $parse) {
  var fileHandler;
  var hasCustomHandler = false;

  this.callFileHandler = callFileHandler;
  this.getFileHandler = getFileHandler;
  this.setFileHandler = setFileHandler;

  function callFileHandler(files) {
    var fileHandler = getFileHandler();

    if (!hasCustomHandler) {
      fileHandler($scope, {$files: files});
    } else {
      fileHandler(files);
    }
  }

  function getFileHandler() {
    if (!fileHandler && !hasCustomHandler) {
      try {
        fileHandler = $parse($attrs.onFileDrop);
      } catch (error) {
        console.warn('onFileDrop failed to parse method to call. Expected function as attribute. ' + $element);
        return fileHandler;
      }
    }

    return fileHandler;
  }

  function setFileHandler(fn) {
    fileHandler = fn;
    hasCustomHandler = true;
  }
}


// WEBPACK FOOTER //
// ./src/js/core-utilities/upload-service/FileDropDirective.js